import React, {Suspense, useEffect} from "react";
import {Provider} from "react-redux";
import {BrowserRouter, HashRouter, Route, Routes} from "react-router-dom";
import store from "./redux/store";
import { accountActions } from "./redux/actions/account";

import './App.css';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import "./assets/scss/style.scss";

import Login from "./pages/domain/login/Login";
import DefaultLayout from "./pages/domain/main/DefaultLayout";
import UserDetail from "./pages/domain/user/UserDetail";

const loading = (
    <div className={"pt-3 text-center"}>
        <div className={"sk-spinner sk-spinner-pulse"}/>
    </div>
);

// localStorage에서 사용자 정보 읽기
const getStorageWithExpiry = (key) => {
  try {
    const item = localStorage.getItem(key);
    if (!item) return null;

    const parsedItem = JSON.parse(item);
    // 만료 시간이 설정되어 있고, 현재 시간이 만료 시간을 초과한 경우
    if (parsedItem.expiry && new Date().getTime() > parsedItem.expiry) {
      localStorage.removeItem(key);
      return null;
    }
    return parsedItem.value;
  } catch (error) {
    console.error('localStorage 읽기 오류:', error);
    localStorage.removeItem(key);
    return null;
  }
};

function App() {
    useEffect(() => {
        document.title = process.env.REACT_APP_APP_TITLE || "One Solution";
        
        // 새 창이 열릴 때 localStorage에서 사용자 정보를 읽어서 Redux state 복원
        const savedUser = getStorageWithExpiry('user');
        const savedSessionId = getStorageWithExpiry('sessionId');
        
        if (savedUser) {
            // localStorage에 사용자 정보가 있으면 Redux state에 복원
            // restoreAccount를 사용하여 sessionId를 제거하지 않고 복원
            store.dispatch(accountActions.restoreAccount(savedUser, savedSessionId));
        }
    }, []);

    return (
        <Provider store={store}>
            <HashRouter>
                <Suspense fallback={loading}>
                    <Routes>
                        <Route path={"/"} name={"Login"} element={<Login/>}/>
                        <Route exact path="/login" name="Login Page" element={<Login/>}/>
                        <Route exact path="/main" name="Dashboard" element={<DefaultLayout/>}/>
                        <Route exact path="/dashboard" name="Dashboard" element={<DefaultLayout/>}/>
                        <Route exact path={"/user/detail"} name={"UserDetail"} element={<UserDetail />} />
                        <Route exact path="/*" name="Dashboard" element={<DefaultLayout/>}/>
                        <Route exact path="/**/*" name="Dashboard" element={<DefaultLayout/>}/>
                    </Routes>
                </Suspense>
            </HashRouter>
        </Provider>
    )
}

export default App;
